import * as React from "react";
import { useState } from "react";
import { Col, Table, Pagination, Row } from "antd";
import { LenderListColumn } from "./UploadHistoryColumns";
import { getLenders } from "../../../services/adminController";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import EditModal from "./EditModal"; // the component we made earlier
import { EditOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import BankModal from "./BankModal";
import { EyeOutlined } from "@ant-design/icons"; // Make sure both icons are imported
import { Tooltip } from "antd"; // Optional for hover info
import { generatePath, useNavigate } from "react-router-dom";

export const LenderList: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBankModalOpen, setBankModalOpen] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [selectedLender, setSelectedLender] = useState<any>(null);
  const queryClient = useQueryClient();
   const navigate = useNavigate();

  const {
    data: lenders,
    isPending: isLenderListPending,
    isRefetching: isLenderListRefetching,
  } = useQuery({
    queryKey: ["lenders", currentPageNumber],
    queryFn: () => getLenders(currentPageNumber),
    placeholderData: keepPreviousData,
    refetchOnMount: true,
  });

  const handleEditClick = (record: any) => {
    setSelectedLender(record);
    setIsModalOpen(true);
  };
  const handleOnChange = (page: number, pageSize: number | undefined) => {
    setCurrentPageNumber(page);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLender(null);
  };
  const handleCloseBankModal = () => {
    setBankModalOpen(false);
    setSelectedLender(null);
  };
  const columnsWithEdit = LenderListColumn.map((col) =>
    col.title === "Details"
      ? {
          ...col,
          render: (_: any, record: any) => (
            <div style={{ display: "flex", gap: "12px" }}>
              <Tooltip title="Edit Lender">
                <EditOutlined
                 onClick={(e) => {
                  e.stopPropagation(); 
                  handleEditClick(record);
                }}
                  style={{
                    color: "#1677ff",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                />
              </Tooltip>
              <Tooltip title="View More Details">
                <EyeOutlined
                     onClick={(e) => {
                  e.stopPropagation(); 
                  setSelectedLender(record);
                  setBankModalOpen(true);
                }}
                  style={{
                    color: "#52c41a",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                />
              </Tooltip>
            </div>
          ),
        }
      : col
  );

 
  const handleRowClick = (record : any, index : any) => {
      const detailsPath = generatePath("/lender-analysis/:lenderId", { lenderId: record?.clientId?.toString() });
    console.log('Row clicked:', record, 'at index:', index);
       navigate(detailsPath);
  };

  

  return (
    <Col>
      <Table 
        columns={columnsWithEdit}
        dataSource={lenders?.data || []}
        size="middle"
        pagination={false}
        onRow={(record, index) => ({
        onClick: (event) => handleRowClick(record, index), // Click event for the row
      })}
        rowKey="clientId"
        loading={isLenderListPending || isLenderListRefetching}
        style={{ cursor: "pointer", marginTop: "10px" }}
      />
      <Row className="flex justify-center pt-6 pb-6">
        <Pagination
          //   showSizeChanger
          pageSize={lenders?.pageSize}
          total={lenders?.totalResults}
          onChange={handleOnChange}
          current={lenders?.currentPage}
        />
      </Row>
      <EditModal
        open={isModalOpen}
        onCancel={handleCloseModal}
        initialData={selectedLender}
        queryClient={queryClient}
      />
      <BankModal
        open={isBankModalOpen}
        onCancel={handleCloseBankModal}
        initialData={selectedLender}
      />
    </Col>
  );
};
